import { useMutation } from "react-query";
import {
  SetVehiclePremiumPolicyDataParams,
  setVehiclePremiumPolicyData,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const setVehiclePremiumPolicyDataFn = async (
  params: SetVehiclePremiumPolicyDataParams,
) => {
  return await setVehiclePremiumPolicyData(params);
};

export function useSetVehiclePremiumPolicyData() {
  return useMutation(setVehiclePremiumPolicyDataFn, {
    mutationKey: MUTATION_KEYS.setVehiclePremiumPolicyData,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
